export default "__VITE_ASSET__DubE3m7l__"